import { render } from "./EnrolleeKillAccountOnboardComponent.vue?vue&type=template&id=38ca8362&scoped=true"
import script from "./EnrolleeKillAccountOnboardComponent.vue?vue&type=script&lang=js"
export * from "./EnrolleeKillAccountOnboardComponent.vue?vue&type=script&lang=js"

import "./EnrolleeKillAccountOnboardComponent.vue?vue&type=style&index=0&id=38ca8362&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38ca8362"]])

export default __exports__